export const GOOGLE_MAPS_API_KEY = 'AIzaSyByE6FSUJDgdCT85Cq-98vSNvoK4tDMRQQ'
